module.exports = __webpack_public_path__ + "img/3_2.d0e31d6d.png";